<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #EEEEE7; height:100% ">
        <v-toolbar class="slide-card-up mb-8" dense :color="'FBFAF1'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo7.svg" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-row dense class="slide-card-up" justify="center">
            <h1 v-if="camino != null" class="mt-0 ma-4 mr-12">{{ $t('mensajes.inicial') }} {{ esAgencia ?
                this.agencia.nombre : '' }}</h1>
        </v-row>
        <v-row v-if="camino != null" dense class="slide-card-up">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    {{ $t('mensajes.descripcion') }}
                </p>
            </v-col>
        </v-row>

        <v-container>
            <v-row justify="center">
                <v-col cols="12" md="10" lg="8">
                    <v-card class="mx-2 pa-6 card-personalizada slide-card">
                        <div class="text-center mb-6">
                            <div class="text-subtitle-2">{{ fechaTexto }}</div>
                            <div class="text-h6 font-weight-bold">{{ tituloAutorizacion }}</div>
                        </div>

                        <v-row v-if="autorizacionEnviada" dense class="mb-4">
                            <v-col cols="12">
                                <v-alert type="success" dense outlined>
                                    {{ copy.mensajeExito }}
                                </v-alert>
                            </v-col>
                        </v-row>

                        <v-form ref="formAutorizacion">
                            <v-row dense>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.numeroTarjeta" :label="labels.numeroTarjeta"
                                        placeholder="VISA / MASTERCARD" outlined dense hide-details
                                        :rules="rulesNumeroTarjeta" maxlength="16" :disabled="camposDeshabilitados"
                                        @input="onInputNumeroTarjeta"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.fechaCaducidad" :label="labels.fechaCaducidad"
                                        placeholder="MM/AA" outlined dense hide-details
                                        :rules="rulesCaducidad" maxlength="5" :disabled="camposDeshabilitados"
                                        @input="onInputCaducidad"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.titularTarjeta" :label="labels.titularTarjeta"
                                        outlined dense hide-details :disabled="camposDeshabilitados"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.importeCarga" :label="labels.importeCarga"
                                        outlined dense hide-details :disabled="camposDeshabilitados"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <div class="text-h6 mt-6">
                                        {{ copy.depositoIntro }}
                                    </div>
                                </v-col>
                                
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.importeDeposito" :label="labels.importeDeposito"
                                        outlined dense hide-details :disabled="camposDeshabilitados"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field ref="fechaDeposito" v-model="autorizacion.fechaDeposito" :label="labels.fechaDeposito"
                                        placeholder="__/__/____" outlined dense hide-details
                                        :rules="rulesFechaDeposito" maxlength="10" :disabled="camposDeshabilitados"
                                        @input="onInputFechaDeposito"></v-text-field>
                                    <div class="caption grey--text mt-1">Formato: DD/MM/YYYY</div>
                                </v-col>
                                <v-col cols="12">
                                    <div class="text-h6 mt-6">
                                        {{ copy.restoIntro }}
                                    </div>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.importeResto" :label="labels.importeResto"
                                        outlined dense hide-details readonly :disabled="camposDeshabilitados"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row justify="center" class="mt-6">
                            <v-chip link large @click="_enviarAutorizacion()" class="ma-2 px-8 mr-8"
                                :class="{ 'hover-color': puedeEnviarAutorizacion }"
                                :color="puedeEnviarAutorizacion ? miColorAzul : 'grey'"
                                :text-color="puedeEnviarAutorizacion ? miColorNaranja : 'white'"
                                style="font-size: 1.1rem;" :disabled="!puedeEnviarAutorizacion">
                                ENVIAR AUTORIZACION
                                <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                            </v-chip>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            language: 'es',

            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',
            miColorAmarillo: '#FFF6E5',

            loadingEnviandoAutorizacion: false,
            hash: null,
            autorizacionEnviada: false,

            autorizacion: {
                numeroTarjeta: '',
                fechaCaducidad: '',
                titularTarjeta: '',
                importeCarga: '',
                importeDeposito: '100',
                fechaDeposito: '',
                importeResto: '',
            },

            modelReserva: {
                id: null,
                codigo: null,
                camino: null,
                fecha_inicio: null,
                fecha_llegada: null,
                cant_peregrinos: 0,
                importe_presupuestado: 0,
                cliente: {
                    nombre: '',
                    apellidos: '',
                    telefono: '',
                    email: '',
                },
            },
        };
    },
    computed: {
        ...mapState('caminos', ['camino', 'agencia']),

        localeActual() {
            const locale = this.language || (this.$i18n && this.$i18n.locale) || 'es';
            return locale.toLowerCase();
        },

        copy() {
            const textos = {
                es: {
                    clienteGenerico: 'cliente',
                    titulo: 'Autorizacion de {nombre} para el uso de la siguiente tarjeta de credito en el cargo de los servicios proporcionados por RUTAS MEIGAS SL',
                    depositoIntro: 'Estoy de acuerdo con que se carguen el siguiente deposito en la fecha indicada:',
                    restoIntro: 'Estoy de acuerdo con que se cargue el resto de la reserva 10 días antes de la fecha de inicio de la misma.',
                    mensajeExito: 'Se ha enviado la autorizacion correctamente. Gracias',
                    labels: {
                        numeroTarjeta: 'Número de tarjeta de credito (VISA / MASTERCARD)',
                        fechaCaducidad: 'Fecha de caducidad (MM/AA)',
                        titularTarjeta: 'Titular',
                        importeCarga: 'Importe a cargar (EUR)',
                        importeDeposito: 'Deposito a cargar (EUR)',
                        fechaDeposito: 'Fecha del deposito',
                        importeResto: 'Resto de la reserva (EUR)',
                    },
                },
                en: {
                    clienteGenerico: 'customer',
                    titulo: 'Authorization of {nombre} to use the following credit card for the charge of the services provided by RUTAS MEIGAS SL',
                    depositoIntro: 'I agree that the following deposit will be charged on the specified date:',
                    restoIntro: 'I agree that the remaining balance will be charged 10 days before the start date.',
                    mensajeExito: 'Authorization sent successfully. Thank you',
                    labels: {
                        numeroTarjeta: 'Credit card number (VISA / MASTERCARD)',
                        fechaCaducidad: 'Expiry date (MM/YY)',
                        titularTarjeta: 'Cardholder',
                        importeCarga: 'Amount to charge (EUR)',
                        importeDeposito: 'Deposit to charge (EUR)',
                        fechaDeposito: 'Deposit charge date',
                        importeResto: 'Remaining balance (EUR)',
                    },
                },
                de: {
                    clienteGenerico: 'Kunde',
                    titulo: 'Autorisierung von {nombre} zur Nutzung der folgenden Kreditkarte fur die Belastung der von RUTAS MEIGAS SL erbrachten Leistungen',
                    depositoIntro: 'Ich stimme zu, dass die folgende Anzahlung am angegebenen Datum belastet wird:',
                    restoIntro: 'Ich stimme zu, dass der Restbetrag 10 Tage vor dem Startdatum belastet wird.',
                    mensajeExito: 'Autorisierung erfolgreich gesendet. Vielen Dank',
                    labels: {
                        numeroTarjeta: 'Kreditkartennummer (VISA / MASTERCARD)',
                        fechaCaducidad: 'Ablaufdatum (MM/JJ)',
                        titularTarjeta: 'Karteninhaber',
                        importeCarga: 'Zu belastender Betrag (EUR)',
                        importeDeposito: 'Anzahlung (EUR)',
                        fechaDeposito: 'Datum der Anzahlung',
                        importeResto: 'Restbetrag (EUR)',
                    },
                },
            };
            return textos[this.localeActual] || textos.es;
        },

        labels() {
            return this.copy.labels;
        },

        rulesNumeroTarjeta() {
            return [
                (v) => {
                    const digits = String(v || '').replace(/\D/g, '');
                    return digits.length === 16 || 'El numero de tarjeta debe tener 16 digitos';
                },
            ];
        },

        rulesCaducidad() {
            return [
                (v) => {
                    const valor = String(v || '');
                    if (!/^\d{2}\/\d{2}$/.test(valor)) return 'Formato MM/AA';
                    const [mm] = valor.split('/');
                    const mes = Number(mm);
                    return mes >= 1 && mes <= 12 || 'Mes invalido';
                },
            ];
        },

        rulesFechaDeposito() {
            return [
                (v) => {
                    const valor = String(v || '');
                    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) return 'Formato dd/mm/aaaa';
                    const [dd, mm, yyyy] = valor.split('/');
                    const dia = Number(dd);
                    const mes = Number(mm);
                    const ano = Number(yyyy);
                    if (mes < 1 || mes > 12) return 'Mes invalido';
                    if (dia < 1 || dia > 31) return 'Dia invalido';
                    if (ano < 1900) return 'Ano invalido';
                    return true;
                },
            ];
        },

        clienteNombreCompleto() {
            const nombre = this.modelReserva.cliente.nombre || '';
            const apellidos = this.modelReserva.cliente.apellidos || '';
            const full = `${nombre} ${apellidos}`.trim();
            return full || this.copy.clienteGenerico;
        },

        tituloAutorizacion() {
            return this.copy.titulo.replace('{nombre}', this.clienteNombreCompleto);
        },

        fechaTexto() {
            return this.formatFecha(new Date());
        },

        camposAutorizacionCompletos() {
            return this.validarCamposAutorizacion();
        },

        camposDeshabilitados() {
            return this.autorizacionEnviada || this.loadingEnviandoAutorizacion;
        },

        puedeEnviarAutorizacion() {
            return !this.loadingEnviandoAutorizacion && !!this.hash && this.camposAutorizacionCompletos && !this.autorizacionEnviada;
        },

        esAgencia() {
            return this.agencia != null && this.agencia.id != 1;
        },
    },
    watch: {
        'autorizacion.importeDeposito'() {
            this._actualizarImporteResto();
        },
        'modelReserva.importe_presupuestado'() {
            if (!this.autorizacion.importeCarga) {
                this.autorizacion.importeCarga = this._formatNumero(this.modelReserva.importe_presupuestado);
            }
            this._actualizarImporteResto();
        },
    },

    mounted() {
        this.language = this.$route.params.language ? this.$route.params.language.toLowerCase() : 'es';
        this.$i18n.locale = this.language;
        const hash = this.$route.params.hash;
        this.hash = hash || null;
        if (hash) {
            this._getReservaByHash(hash);
        }
    },

    methods: {
        ...mapActions('caminos', ['getReservaByHash', 'guardarAutorizacionTarjeta']),

        async _getReservaByHash(hash) {
            const reserva = await this.getReservaByHash([hash]);
            if (!reserva) return;
            this.modelReserva.id = reserva.id;
            this.modelReserva.codigo = reserva.codigo;
            this.modelReserva.fecha_inicio = reserva.fecha_inicio;
            this.modelReserva.fecha_llegada = reserva.fecha_llegada;
            this.modelReserva.cant_peregrinos = reserva.cant_peregrinos;
            this.modelReserva.importe_presupuestado = reserva.importe_presupuestado || 0;
            this.modelReserva.camino = reserva.camino;
            this.modelReserva.cliente.nombre = reserva.cliente.nombre;
            this.modelReserva.cliente.apellidos = reserva.cliente.apellidos;
            this.modelReserva.cliente.telefono = reserva.cliente.telefono;
            this.modelReserva.cliente.email = reserva.cliente.email;

            this._setAutorizacionFromReserva(reserva);
            this._setImportesIniciales();
        },

        async _enviarAutorizacion() {
            if (!this.puedeEnviarAutorizacion) return;
            if (this.$refs.formAutorizacion && !this.$refs.formAutorizacion.validate()) return;
            this.loadingEnviandoAutorizacion = true;
            const payload = {
                autorizacion_numerotarjeta: this.autorizacion.numeroTarjeta,
                autorizacion_fechacaducidad: this.autorizacion.fechaCaducidad,
                autorizacion_titular: this.autorizacion.titularTarjeta,
                autorizacion_importecarga: this.autorizacion.importeCarga,
                autorizacion_importedeposito: this.autorizacion.importeDeposito,
                autorizacion_fechadeposito: this.autorizacion.fechaDeposito,
                autorizacion_importeresto: this.autorizacion.importeResto,
            };
            const response = await this.guardarAutorizacionTarjeta([this.hash, payload]);
            this.loadingEnviandoAutorizacion = false;
            if (response) {
                this.autorizacionEnviada = true;
            }
            return response;
        },

        _setImportesIniciales() {
            if (!this.autorizacion.importeCarga) {
                this.autorizacion.importeCarga = this._formatNumero(this.modelReserva.importe_presupuestado);
            }
            if (!this.autorizacion.importeDeposito) {
                this.autorizacion.importeDeposito = '100';
            }
            if (!this.autorizacion.titularTarjeta) {
                const titular = this._getTitularPorDefecto();
                if (titular) {
                    this.autorizacion.titularTarjeta = titular;
                }
            }
            this._actualizarImporteResto();
        },

        _setAutorizacionFromReserva(reserva) {
            if (!reserva) return;
            if (reserva.autorizacion_numerotarjeta) {
                this.autorizacion.numeroTarjeta = String(reserva.autorizacion_numerotarjeta);
            }
            if (reserva.autorizacion_fechacaducidad) {
                this.autorizacion.fechaCaducidad = String(reserva.autorizacion_fechacaducidad);
            }
            if (reserva.autorizacion_titular) {
                this.autorizacion.titularTarjeta = String(reserva.autorizacion_titular);
            }
            if (reserva.autorizacion_importedeposito !== null && reserva.autorizacion_importedeposito !== undefined) {
                this.autorizacion.importeDeposito = this._formatNumero(reserva.autorizacion_importedeposito);
            }
            if (reserva.autorizacion_fechadeposito) {
                this.autorizacion.fechaDeposito = this._formatFechaDepositoDesdeApi(reserva.autorizacion_fechadeposito);
            }
            if (reserva.autorizacion_importeresto !== null && reserva.autorizacion_importeresto !== undefined) {
                this.autorizacion.importeResto = this._formatNumero(reserva.autorizacion_importeresto);
            }
        },

        _actualizarImporteResto() {
            const total = this._parseNumero(this.modelReserva.importe_presupuestado);
            const deposito = this._parseNumero(this.autorizacion.importeDeposito);
            const resto = Math.max(0, total - deposito);
            this.autorizacion.importeResto = this._formatNumero(resto);
        },

        _parseNumero(valor) {
            if (valor === null || valor === undefined) return 0;
            const limpio = String(valor).replace(',', '.').replace(/[^\d.]/g, '');
            const num = Number.parseFloat(limpio);
            return Number.isNaN(num) ? 0 : num;
        },

        _formatNumero(valor) {
            const num = this._parseNumero(valor);
            return Number.isInteger(num) ? String(num) : num.toFixed(2);
        },

        _getTitularPorDefecto() {
            const nombre = (this.modelReserva.cliente.nombre || '').trim();
            const apellidos = (this.modelReserva.cliente.apellidos || '').trim();
            const full = `${nombre} ${apellidos}`.trim();
            return full || '';
        },

        _formatFechaDepositoDesdeApi(valor) {
            const texto = String(valor || '').trim();
            const match = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (match) {
                const [, yyyy, mm, dd] = match;
                return `${dd}/${mm}/${yyyy}`;
            }
            return texto;
        },

        onInputNumeroTarjeta(valor) {
            const digits = String(valor || '').replace(/\D/g, '').slice(0, 16);
            this.autorizacion.numeroTarjeta = digits;
        },

        onInputCaducidad(valor) {
            let digits = String(valor || '').replace(/\D/g, '').slice(0, 4);
            if (digits.length >= 3) {
                digits = `${digits.slice(0, 2)}/${digits.slice(2)}`;
            } else if (digits.length >= 2) {
                digits = `${digits.slice(0, 2)}/${digits.slice(2)}`;
            }
            this.autorizacion.fechaCaducidad = digits;
        },

        onInputFechaDeposito(valor) {
            const texto = String(valor || '');
            const input = this._getInputFechaDeposito();
            const cursor = input && typeof input.selectionStart === 'number'
                ? input.selectionStart
                : texto.length;
            const digitosAntesDelCursor = texto.slice(0, cursor).replace(/\D/g, '').length;
            const digitos = texto.replace(/\D/g, '').slice(0, 8);
            const fechaFormateada = this._formatearFechaDeposito(digitos);

            this.autorizacion.fechaDeposito = fechaFormateada;
            this.$nextTick(() => {
                const inputActualizado = this._getInputFechaDeposito();
                if (!inputActualizado) return;
                const nuevaPosicion = this._getPosicionCursorFechaDeposito(
                    fechaFormateada,
                    digitosAntesDelCursor,
                    texto.charAt(cursor) === '/'
                );
                inputActualizado.setSelectionRange(nuevaPosicion, nuevaPosicion);
            });
        },

        _getInputFechaDeposito() {
            const campo = this.$refs.fechaDeposito;
            if (!campo) return null;
            return campo.$refs.input || campo.$el.querySelector('input');
        },

        _formatearFechaDeposito(digitos) {
            if (digitos.length <= 2) return digitos;
            if (digitos.length <= 4) return `${digitos.slice(0, 2)}/${digitos.slice(2)}`;
            return `${digitos.slice(0, 2)}/${digitos.slice(2, 4)}/${digitos.slice(4)}`;
        },

        _getPosicionCursorFechaDeposito(fecha, digitosAntesDelCursor, habiaBarraEnCursor) {
            if (!digitosAntesDelCursor) return 0;

            let digitosRecorridos = 0;
            for (let posicion = 0; posicion < fecha.length; posicion++) {
                if (/\d/.test(fecha.charAt(posicion))) digitosRecorridos++;
                if (digitosRecorridos === digitosAntesDelCursor) {
                    let nuevaPosicion = posicion + 1;
                    if (!habiaBarraEnCursor && fecha.charAt(nuevaPosicion) === '/') {
                        nuevaPosicion++;
                    }
                    return nuevaPosicion;
                }
            }
            return fecha.length;
        },

        validarCamposAutorizacion() {
            const campos = [
                'numeroTarjeta',
                'fechaCaducidad',
                'titularTarjeta',
                'importeCarga',
                'importeDeposito',
                'fechaDeposito',
                'importeResto',
            ];
            const completos = campos.every((campo) => {
                const valor = this.autorizacion[campo];
                return valor !== null && valor !== undefined && String(valor).trim() !== '';
            });
            if (!completos) return false;
            const rulesNumero = this.rulesNumeroTarjeta;
            const rulesCad = this.rulesCaducidad;
            const rulesFecha = this.rulesFechaDeposito;
            const okNumero = rulesNumero.every((r) => r(this.autorizacion.numeroTarjeta) === true);
            const okCad = rulesCad.every((r) => r(this.autorizacion.fechaCaducidad) === true);
            const okFecha = rulesFecha.every((r) => r(this.autorizacion.fechaDeposito) === true);
            return okNumero && okCad && okFecha;
        },

        formatFecha(date) {
            const localeMap = {
                es: 'es-ES',
                en: 'en-US',
                de: 'de-DE',
            };
            const locale = localeMap[this.localeActual] || 'es-ES';
            try {
                return new Intl.DateTimeFormat(locale, {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).format(date);
            } catch (e) {
                return date.toLocaleDateString();
            }
        },
    },
}

</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/css/flag-icon.min.css';

.card-personalizada {
    border: 4px solid #FF9C00 !important;
    border-radius: 15px !important;
}

.slide-card {
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.slide-card-up {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
